import React from 'react';
import { useFirebaseAuth } from '../contexts/FirebaseAuthProvider';

export const AdminGuard = ({ children }) => {
  const { user, loading } = useFirebaseAuth();

  if (loading) {
    return (
      <div style={containerStyles}>
        <div style={spinnerStyles}></div>
        <p style={textStyles}>Verifying credentials...</p>
      </div>
    );
  }

  // Strict email check
  if (!user || user.email !== 'andrew.green.contact@gmail.com') {
    // Render a silent, clean 404 page (no redirection, no hints that the admin route exists)
    return (
      <div style={errorContainerStyles}>
        <h1 style={errorCodeStyles}>404</h1>
        <div style={dividerStyles}></div>
        <p style={errorMessageStyles}>This page could not be found.</p>
      </div>
    );
  }

  return <>{children}</>;
};

// Styling definitions
const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
  backgroundColor: '#0a0b0d',
  color: '#e2e8f0',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
};

const spinnerStyles = {
  width: '40px',
  height: '40px',
  border: '3px solid rgba(255, 255, 255, 0.05)',
  borderTop: '3px solid #6366f1',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
  marginBottom: '16px',
};

const textStyles = {
  fontSize: '14px',
  color: '#94a3b8',
  letterSpacing: '0.05em',
};

const errorContainerStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
  backgroundColor: '#0a0b0d',
  color: '#e2e8f0',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
};

const errorCodeStyles = {
  fontSize: '24px',
  fontWeight: 500,
  margin: 0,
  paddingRight: '23px',
  lineHeight: '49px',
};

const dividerStyles = {
  height: '40px',
  width: '1px',
  backgroundColor: 'rgba(255, 255, 255, 0.15)',
  marginRight: '23px',
};

const errorMessageStyles = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '49px',
  margin: 0,
};
